import { Outlet } from 'react-router-dom';
import ApplicationJobHeaderKanban from './ApplicationJobHeaderKanban';

const Kanban = () => {

  return (
    <>
      <ApplicationJobHeaderKanban />
      <Outlet />
    </>

  );
};

export default Kanban;
